import { Equipe } from './equipe.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class EquipeService {

    constructor(private http: Http) {
    }

    getEquipes(): Observable<Equipe[]> {
        return this.http.get(`${NTECH_API}/equipes`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/equipe/equipe.service.ts